import React from 'react';

const LoadingTransition = ({companylogo = "/static/images/snlpic.png", message}) => (
  <div className="fixed inset-0 bg-gray-800 bg-opacity-90 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-xl max-w-sm w-full p-6">
      <div className="flex flex-col items-center">
        {companylogo && <img src={companylogo} alt="Company Logo" className="h-12 w-auto mb-6" />}
        
        <div className="mb-4 flex items-center justify-center">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-800"></div>
        </div>
        
        <h3 className="text-lg font-medium text-gray-800 mb-2">Preparing Onboarding</h3>
        <p className="text-sm text-gray-600 text-center">
          {message || "Your access has been validated. Loading your onboarding dashboard..."}
        </p>
      </div>
    </div>
  </div>
);

export default LoadingTransition;